import React from "react";

//Custom Components
import PrijevozniciPage from "UI/AppPage/PrijevozniciPage";
import ResponsiveBox from "UI/Box/ResponsiveBox";
import BurzaTable from "Views/Prijevoznici/Burza/BurzaTable";

const PrijevozniciBurzaPage = React.memo((props) => {
  return (
    <PrijevozniciPage>
      <ResponsiveBox fillHeight>
        <BurzaTable viewName="burza_upiti_javno" />
      </ResponsiveBox>
    </PrijevozniciPage>
  );
});

export default PrijevozniciBurzaPage;
